import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { timeZoneSelector } from 'Features/App/appSlice';
import { createUseStyles } from 'react-jss';
import { Dialog, Pane, Strong, Text } from 'evergreen-ui';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import { TimeseriesContext } from '../Timeseries.Context';
import { TableCellProps } from './types';
import EditTimeSeriesData from './EditTimeSeriesData';

const useStyles = createUseStyles({
  displayContents: {
    '& > div': {
      display: 'contents',
    },
  },
});

// TODO: тип
export const EditTimeSeriesContext = React.createContext<any>(null);

const { Provider } = EditTimeSeriesContext;

export function EditTimeSeriesProvider({ children }: PropsWithChildren) {
  const classes = useStyles();
  const selectedZone = useSelector(timeZoneSelector);
  const { sourceId } = React.useContext(TimeseriesContext);
  const [editedValue, setEditedValue] = React.useState<TableCellProps | null>(null);

  const Title = React.useCallback(() => (
    <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" rowGap=".3rem">
      <Strong fontSize={18}>{`${UTCtoTimeZone(editedValue?.dateTime, selectedZone.selectedUserTimeZone)} UTC${selectedZone.selectedUserTimeZone} | ${editedValue?.columnData.label}`}</Strong>
      {editedValue?.columnData.entityName && <Text fontSize={14}>{editedValue?.columnData.entityName}</Text>}
    </Pane>
  ), [editedValue, selectedZone.selectedUserTimeZone]);

  const onCloseDialog = () => {
    setEditedValue(null);
  };

  return (
    <Provider value={{ setEditedValue }}>
      {children}
      {editedValue && (
        <Dialog
          onCloseComplete={onCloseDialog}
          title={<Title />}
          width="50%"
          hasCancel={false}
          hasFooter={false}
          shouldCloseOnOverlayClick={false}
          confirmLabel="Применить"
          isShown
          contentContainerProps={{
            className: classes.displayContents,
          }}
        >
          <EditTimeSeriesData data={editedValue} sourceId={sourceId} zone={selectedZone.selectedUserTimeZone} />
        </Dialog>
      )}
    </Provider>
  );
}
